import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyAll,
  getMyPage
} from '@/api/clientinfoserv'

export default {
  state: {
    state_ClientInfo_AddObjResult: null,
    state_ClientInfo_GetAllResult: null,
    state_ClientInfo_SearchByNameResult: null,
    state_ClientInfo_GetPageResult: null,
    state_ClientInfo_GetDetailResult: null,
    state_ClientInfo_ModifyObjResult: null,
    state_ClientInfo_DeleteObjResult: null,
    state_ClientInfo_GetMyAllResult: null,
    state_ClientInfo_GetMyPageResult: null
  },
  mutations: {
    SET_CLIENTINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_ClientInfo_AddObjResult = rst
    },
    SET_CLIENTINFO_GETALL_RESULT: (state, rst) => {
      state.state_ClientInfo_GetAllResult = rst
    },
    SET_CLIENTINFO_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_ClientInfo_SearchByNameResult = rst
    },
    SET_CLIENTINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_ClientInfo_GetPageResult = rst
    },
    SET_CLIENTINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_ClientInfo_GetDetailResult = rst
    },
    SET_CLIENTINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_ClientInfo_ModifyObjResult = rst
    },
    SET_CLIENTINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_ClientInfo_DeleteObjResult = rst
    },
    SET_CLIENTINFO_GETMYALL_RESULT: (state, rst) => {
      state.state_ClientInfo_GetMyAllResult = rst
    },
    SET_CLIENTINFO_GETMYPAGE_RESULT: (state, rst) => {
      state.state_ClientInfo_GetMyPageResult = rst
    }
  },
  actions: {
    ClientInfoServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_GetMyAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_GETMYALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_GETMYALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    ClientInfoServ_GetMyPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_CLIENTINFO_GETMYPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_CLIENTINFO_GETMYPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_ClientInfo_AddObjResult: state => {
      return state.state_ClientInfo_AddObjResult
    },
    get_ClientInfo_GetAllResult: state => {
      return state.state_ClientInfo_GetAllResult
    },
    get_ClientInfo_SearchByNameResult: state => {
      return state.state_ClientInfo_SearchByNameResult
    },
    get_ClientInfo_GetPageResult: state => {
      return state.state_ClientInfo_GetPageResult
    },
    get_ClientInfo_GetDetailResult: state => {
      return state.state_ClientInfo_GetDetailResult
    },
    get_ClientInfo_ModifyObjResult: state => {
      return state.state_ClientInfo_ModifyObjResult
    },
    get_ClientInfo_DeleteObjResult: state => {
      return state.state_ClientInfo_DeleteObjResult
    },
    get_ClientInfo_GetMyAllResult: state => {
      return state.state_ClientInfo_GetMyAllResult
    },
    get_ClientInfo_GetMyPageResult: state => {
      return state.state_ClientInfo_GetMyPageResult
    }
  }
}
